// Test IDs for the executive Dashboard (Admin/Profesional) and the Reportes
// de negocio module (Ingresos, Servicios, Ocupación, Clientes, No-shows,
// Inventario), shared PeriodSelector and export buttons.

export const REPORTS = {
  // Selector de periodo (compartido entre Dashboard y Reportes)
  periodSelector: 'reports-period-selector',
  periodSelectTrigger: 'reports-period-select-trigger',
  periodStartInput: 'reports-period-start-input',
  periodEndInput: 'reports-period-end-input',

  // Dashboard ejecutivo (Admin)
  adminDashboard: 'admin-dashboard',
  kpiToday: 'dashboard-kpi-today',
  kpiWeek: 'dashboard-kpi-week',
  kpiMonth: 'dashboard-kpi-month',
  kpiYear: 'dashboard-kpi-year',
  revenueChart: 'dashboard-revenue-chart',
  topServicesTable: 'dashboard-top-services-table',
  topProfitableTable: 'dashboard-top-profitable-table',
  occupancyList: 'dashboard-occupancy-list',
  occupancyRowPrefix: 'dashboard-occupancy-row-',
  clientsCard: 'dashboard-clients-card',
  noShowCard: 'dashboard-no-show-card',
  inventorySummaryCard: 'dashboard-inventory-summary-card',
  lowStockList: 'dashboard-low-stock-list',

  // Dashboard reducido (Profesional)
  professionalDashboard: 'professional-dashboard',
  professionalOccupancyCard: 'professional-occupancy-card',
  professionalServicesTable: 'professional-services-table',
  professionalNoShowCard: 'professional-no-show-card',

  // Página de Reportes
  page: 'reports-page',
  tabRevenue: 'reports-tab-revenue',
  tabServices: 'reports-tab-services',
  tabOccupancy: 'reports-tab-occupancy',
  tabClients: 'reports-tab-clients',
  tabNoShows: 'reports-tab-no-shows',
  tabInventory: 'reports-tab-inventory',

  revenueBySeries: 'reports-revenue-series-chart',
  revenueByService: 'reports-revenue-by-service-table',
  revenueByProfessional: 'reports-revenue-by-professional-table',
  revenueByMethod: 'reports-revenue-by-method-table',
  revenueTotal: 'reports-revenue-total',

  servicesMostSoldTable: 'reports-services-most-sold-table',
  servicesMostProfitableTable: 'reports-services-most-profitable-table',

  occupancyTable: 'reports-occupancy-table',

  clientsNewCount: 'reports-clients-new-count',
  clientsReturningCount: 'reports-clients-returning-count',
  clientsInactiveList: 'reports-clients-inactive-list',
  clientsInactiveDaysInput: 'reports-clients-inactive-days-input',

  noShowRateCard: 'reports-no-show-rate-card',
  noShowByProfessionalTable: 'reports-no-show-by-professional-table',
  noShowByServiceTable: 'reports-no-show-by-service-table',

  inventoryConsumptionTable: 'reports-inventory-consumption-table',

  exportButtonPrefix: 'reports-export-button-', // + report key
  exportExcelOptionPrefix: 'reports-export-excel-option-',
  exportCsvOptionPrefix: 'reports-export-csv-option-',
};
